import { QuarterDateInput } from '@containers/form/QuarterDateInput';
import { Body5, Container } from '@ui';
import styled from 'styled-components';

const SectionHeader = styled.div`
  font-weight: 600;
  font-size: 16px;
  margin-top: 16px;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.themeColors.text};
`;
const InputLabel = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: ${({ theme }) => theme.themeColors.text};
`;
const SelectInput = styled.select`
  border: 1px solid ${({ theme }) => theme.themeColors.border};
  color: ${({ theme }) => theme.themeColors.text};
  background-color: transparent;
  border-radius: 6px;
  width: 100%;
  padding: 12px 16px;
  -webkit-appearance: auto !important;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: ${({ theme }) => theme.themeColors.disabledBackground || 'rgba(0, 0, 0, 0.05)'};
  }
`;
const TextInput = styled.input`
  border: 1px solid ${({ theme }) => theme.themeColors.border};
  color: ${({ theme }) => theme.themeColors.text};
  background-color: transparent;
  border-radius: 6px;
  width: 100%;
  padding: 12px 16px;
`;
const ModeExtraParamsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: ${({ Top }) => Top || 0}px;
`;

function ModeExtraParamInput({ param, value, onChange, allParams }) {
  if (param === 'fiscal') {
    return (
      <Container>
        <InputLabel>Fiscal</InputLabel>
        <SelectInput value={value} onChange={onChange}>
          <option value="">Select Fiscal</option>
          <option value="Month">Month</option>
          <option value="Quarter">Quarter</option>
          <option value="Year">Year</option>
        </SelectInput>
      </Container>
    );
  }
  if (param === 'quarter_section_header') {
    return <SectionHeader>Quarter</SectionHeader>;
  }
  if (param === 'year_section_header') {
    return <SectionHeader>Year</SectionHeader>;
  }
  if (param === 'fund_name') {
    return (
      <Container>
        <InputLabel>Fund Name</InputLabel>
        <TextInput value={value} onChange={onChange} placeholder="Enter fund name" />
      </Container>
    );
  }
  if (param === 'calendar_date') {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    // Parse current value
    const parseValue = (val) => {
      if (!val) return { month: '', year: '' };
      const parts = val.split(' ');
      return {
        month: parts[0] || '',
        year: parts[1] || '',
      };
    };

    const currentValue = parseValue(value);
    const selectedMonth = currentValue.month;
    const selectedYear = currentValue.year;

    // Generate year options
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = 1; i >= -10; i--) {
      years.push(currentYear + i);
    }

    const handleMonthChange = (e) => {
      const newMonth = e.target.value;
      if (newMonth === 'Month' || newMonth === '') {
        return;
      }
      const newValue = selectedYear ? `${newMonth} ${selectedYear}` : `${newMonth} 1`;
      onChange({ target: { value: newValue } });
    };

    const handleYearChange = (e) => {
      const newYear = e.target.value;
      const newValue = selectedMonth ? `${selectedMonth} ${newYear}` : '';
      onChange({ target: { value: newValue } });
    };

    return (
      <Container>
        <InputLabel>Fiscal Quarter End Date</InputLabel>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', maxWidth: '200px' }}>
          <SelectInput value={selectedMonth} onChange={handleMonthChange}>
            <option value="">Month</option>
            {monthNames.map((month) => (
              <option key={month} value={month}>
                {month}
              </option>
            ))}
          </SelectInput>
          <SelectInput value={selectedYear} onChange={handleYearChange} disabled={!selectedMonth}>
            <option value="">Year</option>
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </SelectInput>
        </div>
      </Container>
    );
  }
  if (param === 'quarter_section_header') {
    return <SectionHeader>Quarter</SectionHeader>;
  }
  if (param === 'year_section_header') {
    return <SectionHeader>Year</SectionHeader>;
  }
  if (param === 'calendar_date' || param === 'fiscal_year_end_date') {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    // Parse current value
    const parseValue = (val) => {
      if (!val) return { month: '', year: '' };
      const parts = val.split(' ');
      return {
        month: parts[0] || '',
        year: parts[1] || '',
      };
    };

    const currentValue = parseValue(value);
    const selectedMonth = currentValue.month;
    const selectedYear = currentValue.year;

    // Generate year options
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = 1; i >= -10; i--) {
      years.push(currentYear + i);
    }

    const handleMonthChange = (e) => {
      const newMonth = e.target.value;
      if (newMonth === 'Month' || newMonth === '') {
        return;
      }
      const newValue = selectedYear ? `${newMonth} ${selectedYear}` : `${newMonth} 1`;
      onChange({ target: { value: newValue } });
    };

    const handleYearChange = (e) => {
      const newYear = e.target.value;
      const newValue = selectedMonth ? `${selectedMonth} ${newYear}` : '';
      onChange({ target: { value: newValue } });
    };

    return (
      <Container>
        <InputLabel>{param === 'calendar_date' ? 'Calendar Date' : 'Fiscal Year End Date'}</InputLabel>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', maxWidth: '200px' }}>
          <SelectInput value={selectedMonth} onChange={handleMonthChange}>
            <option value="">Month</option>
            {monthNames.map((month) => (
              <option key={month} value={month}>
                {month}
              </option>
            ))}
          </SelectInput>
          <SelectInput value={selectedYear} onChange={handleYearChange} disabled={!selectedMonth}>
            <option value="">Select Year</option>
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </SelectInput>
        </div>
      </Container>
    );
  }
  if (param === 'quarter_end_date') {
    return (
      <QuarterDateInput
        label="Calendar Date of Fiscal Quarter End (MMM YYYY)"
        value={value}
        onChange={onChange}
        isQuarterEnd={true}
      />
    );
  }
  if (param === 'fiscal_quarter') {
    const fiscalValue = allParams?.fiscal;
    const isMonthMode = !fiscalValue || fiscalValue === 'Month';

    if (isMonthMode) {
      // Show months when fiscal is "Month"
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      return (
        <Container>
          <InputLabel>Fiscal Month</InputLabel>
          <SelectInput value={value} onChange={onChange}>
            <option value="">Select Month</option>
            {monthNames.map((month) => (
              <option key={month} value={month}>
                {month}
              </option>
            ))}
          </SelectInput>
        </Container>
      );
    } else {
      // Show quarters when fiscal is "Quarter" or "Year"
      return (
        <Container>
          <InputLabel>Fiscal Quarter</InputLabel>
          <SelectInput value={value} onChange={onChange}>
            <option value="">Select Quarter</option>
            <option value="1Q">Q1</option>
            <option value="2Q">Q2</option>
            <option value="3Q">Q3</option>
            <option value="4Q">Q4</option>
          </SelectInput>
        </Container>
      );
    }
  }
  if (param === 'fiscal_quarter_fiscal_year') {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = 1; i >= -10; i--) {
      years.push(currentYear + i);
    }

    return (
      <Container>
        <InputLabel>Fiscal Quarter Fiscal Year (YYYY)</InputLabel>
        <SelectInput value={value} onChange={onChange}>
          <option value="">Select Year</option>
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </SelectInput>
      </Container>
    );
  }
  if (param === 'quarter_fiscal_year' || param === 'year_fiscal_year' || param === 'fiscal_year') {
    const currentYear = new Date().getFullYear();
    const years = [];
    // Start from one year in the future
    for (let i = 1; i >= -10; i--) {
      years.push(currentYear + i);
    }

    return (
      <Container>
        <InputLabel>Fiscal Year (YYYY)</InputLabel>
        <SelectInput value={value} onChange={onChange}>
          <option value="">Select Year</option>
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </SelectInput>
      </Container>
    );
  }
  if (param === 'fiscal_quarter_e_or_a') {
    return (
      <Container>
        <InputLabel>Fiscal Quarter Estimate or Actual (E / A)</InputLabel>
        <SelectInput value={value} onChange={onChange}>
          <option value="E">E - Estimate</option>
          <option value="A">A - Actual</option>
        </SelectInput>
      </Container>
    );
  }
  if (param === 'fiscal_year_e_or_a') {
    return (
      <Container>
        <InputLabel>Fiscal Year Estimate or Actual (E / A)</InputLabel>
        <SelectInput value={value} onChange={onChange}>
          <option value="E">E - Estimate</option>
          <option value="A">A - Actual</option>
        </SelectInput>
      </Container>
    );
  }
  if (param === 'year_ago_fiscal_year_e_or_a') {
    return (
      <Container>
        <InputLabel>Year Ago Fiscal Year Estimate or Actual (E / A)</InputLabel>
        <SelectInput value={value} onChange={onChange}>
          <option value="E">E - Estimate</option>
          <option value="A">A - Actual</option>
        </SelectInput>
      </Container>
    );
  }
  if (param === 'quarter_estimate_or_actual' || param === 'year_estimate_or_actual' || param === 'e_or_a') {
    return (
      <Container>
        <InputLabel>Estimate or Actual (E / A)</InputLabel>
        <SelectInput value={value} onChange={onChange}>
          <option value="E">E - Estimate</option>
          <option value="A">A - Actual</option>
        </SelectInput>
      </Container>
    );
  }
  if (
    param === 'year_ago_fiscal_quarter_e_or_a' ||
    param === 'quarter_year_ago_estimate_or_actual' ||
    param === 'year_year_ago_estimate_or_actual'
  ) {
    return (
      <Container>
        <InputLabel>Year Ago Estimate or Actual (E / A)</InputLabel>
        <SelectInput value={value} onChange={onChange}>
          <option value="E">E - Estimate</option>
          <option value="A">A - Actual</option>
        </SelectInput>
      </Container>
    );
  }
  if (param === 'convert_to_usd') {
    return (
      <Container>
        <InputLabel>Convert to USD</InputLabel>
        <SelectInput value={value} onChange={onChange}>
          <option value="true">Yes</option>
          <option value="false">No</option>
        </SelectInput>
      </Container>
    );
  }
  return <Body5>Unknown parameter: {param}</Body5>;
}
export function ExtraModeParams({ modeExtraParams, modeExtraParamsState, onChangeModeExtraParams, top }) {
  if (modeExtraParams.length === 0) return null;
  return (
    <ModeExtraParamsWrapper Top={top || 0}>
      {modeExtraParams.map((param) => {
        const isHeaderParam = param.includes('_section_header');
        return (
          <ModeExtraParamInput
            key={param}
            param={param}
            value={isHeaderParam ? undefined : modeExtraParamsState[param]}
            onChange={isHeaderParam ? undefined : (e) => onChangeModeExtraParams(param, e.target.value)}
            allParams={modeExtraParamsState}
          />
        );
      })}
    </ModeExtraParamsWrapper>
  );
}
